import { registerSW } from "virtual:pwa-register";

type UpdateCallback = (needsRefresh: boolean) => void;

let updateCallback: UpdateCallback | null = null;
let updateSWFn: ((reloadPage?: boolean) => Promise<void>) | null = null;

const PAGE_LOAD_TIME = Date.now();
const AUTO_UPDATE_THRESHOLD_MS = 10_000;

/**
 * Register a callback to be notified when a new service worker is waiting.
 * The callback receives `true` when a refresh is needed.
 */
export function onSWUpdate(cb: UpdateCallback): void {
  updateCallback = cb;
}

/**
 * Activate the waiting service worker and reload the page.
 */
export function applyUpdate(): void {
  void updateSWFn?.(true);
}

/**
 * Register the service worker. Call once after React renders.
 *
 * If a new SW is detected within 10s of page load (user just opened the app),
 * auto-apply the update instead of showing a banner — the user hasn't started
 * any meaningful interaction yet, so a reload is safe.
 */
export function registerServiceWorker(): void {
  updateSWFn = registerSW({
    onNeedRefresh() {
      if (Date.now() - PAGE_LOAD_TIME < AUTO_UPDATE_THRESHOLD_MS) {
        void updateSWFn?.(true);
      } else {
        updateCallback?.(true);
      }
    },
    onOfflineReady() {
      console.log("Habits: ready for offline use");
    },
  });
}
